import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import useAuthStore from './store/authStore'
import useAppStore from './store/appStore'
import Sidebar from './components/Sidebar'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Condominios from './pages/Condominios'
import Fracoes from './pages/Fracoes'
import Condominos from './pages/Condominos'
import ContasCorrentes from './pages/ContasCorrentes'
import Despesas from './pages/Despesas'
import Quotas from './pages/Quotas'
import Reconciliacao from './pages/Reconciliacao'
import Reunioes from './pages/Reunioes'
import { Receitas, Documentos, Relatorios } from './pages/OtherPages'

function ProtectedLayout() {
  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-area">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/condominios" element={<Condominios />} />
          <Route path="/fracoes" element={<Fracoes />} />
          <Route path="/condominos" element={<Condominos />} />
          <Route path="/cc" element={<ContasCorrentes />} />
          <Route path="/despesas" element={<Despesas />} />
          <Route path="/receitas" element={<Receitas />} />
          <Route path="/reconciliacao" element={<Reconciliacao />} />
          <Route path="/documentos" element={<Documentos />} />
          <Route path="/reunioes" element={<Reunioes />} />
          <Route path="/relatorios" element={<Relatorios />} />
          <Route path="/quotas" element={<Quotas />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  )
}

export default function App() {
  const { user, init } = useAuthStore()
  const { fetchCondominios } = useAppStore()

  useEffect(() => { init() }, [])
  useEffect(() => { if (user) fetchCondominios() }, [user])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" replace />} />
        <Route path="/*" element={user ? <ProtectedLayout /> : <Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
